// extracted by mini-css-extract-plugin
var _1 = "TradingDetailsStyle-module__button___uL1PY";
var _2 = "TradingDetailsStyle-module__details___uXDqu";
var _3 = "TradingDetailsStyle-module__details-section___Efa1w";
var _4 = "TradingDetailsStyle-module__details-section___Efa1w";
export { _1 as "button", _2 as "details", _3 as "details-section", _4 as "detailsSection" }
